export default __webpack_public_path__ + "static/media/poolHeating.4cc39445.jpg";